import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const AppManagementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppManagement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"me","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"AppManagement","document":AppManagementDocument}} as const;
export type AppManagementQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AppManagementQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id'>
    & { agreements: Array<(
      { __typename: 'Member_Agreement' }
      & Pick<Types.Member_Agreement, 'id' | 'agreementType'>
    )> }
  )> }
);

/**
 * __useAppManagementQuery__
 *
 * To run a query within a React component, call `useAppManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppManagementQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppManagementQuery(
  baseOptions?: TrelloQueryHookOptions<
    AppManagementQuery,
    AppManagementQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: AppManagementDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    AppManagementQuery,
    AppManagementQueryVariables
  >(AppManagementDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useAppManagementLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    AppManagementQuery,
    AppManagementQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AppManagementQuery, AppManagementQueryVariables>(
    AppManagementDocument,
    options,
  );
}
export function useAppManagementSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        AppManagementQuery,
        AppManagementQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AppManagementQuery,
    AppManagementQueryVariables
  >(AppManagementDocument, options);
}
export type AppManagementQueryHookResult = ReturnType<
  typeof useAppManagementQuery
>;
export type AppManagementLazyQueryHookResult = ReturnType<
  typeof useAppManagementLazyQuery
>;
export type AppManagementSuspenseQueryHookResult = ReturnType<
  typeof useAppManagementSuspenseQuery
>;
export type AppManagementQueryResult = Apollo.QueryResult<
  AppManagementQuery,
  AppManagementQueryVariables
>;
